module.exports = __webpack_public_path__ + "img/solutionHead.e8819b33.png";